import { WorkspacePageDefaultInner } from ".";

export default function WorkspaceDefault(props: { tab?: string }) {
	return <WorkspacePageDefaultInner tab={props.tab} />;
}
